import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import profileIcon from '../../../images/insight360/360-generic-profile-icon.png';
import profileIconHappy from '../../../images/insight360/360-profile-icon_happy-life.png';
import profileIconInternational from '../../../images/insight360/360-profile-icon_international.png';
import profileIconMoney from '../../../images/insight360/360-profile-icon_MONEY.png';
import profileIconOptimist from '../../../images/insight360/360-profile-icon_optimist.png';
import profileIconPerfectionist from '../../../images/insight360/360-profile-icon_perfectionist.png';
import profileIconRiskTaker from '../../../images/insight360/360-profile-icon_risk-taker.png';
import profileIconStandOut from '../../../images/insight360/360-profile-icon_stand-out.png';
import profileIconWorkaholic from '../../../images/insight360/360-profile-icon_workaholic.png';
import profileIconWorry from '../../../images/insight360/360-profile-icon_worry.png';
import profileIconAlone from '../../../images/insight360/360-profile-icon_alone.png';
import profileIconArts from '../../../images/insight360/360-profile-icon_arts.png';
import profileIconCrime from '../../../images/insight360/360-profile-icon_crime.png';
import profileIconFamily from '../../../images/insight360/360-profile-icon_family.png';
import ProfileTripleComparisionDetail from '../profiles/ProfileTripleComparisionDetail';
import ProfilesTriplePersonality from '../profiles/ProfilesTriplePersonality';
import ProfileTripleOutlookDetails from '../profiles/ProfileTripleOutlookDetail';
import { getStartIndex } from '../../../util/Insight360Utils';
// MRI Icons
import profileIconSocialStatus from '../../../images/insight360/360-profile-icon_social-status.png';
import profileIconEnvironmentalist from '../../../images/insight360/360-profile-icon_environmentalist.png';
import profileIconSophisticated from '../../../images/insight360/360-profile-icon_sophisticated.png';
import profileIconFun from '../../../images/insight360/360-profile-icon_fun.png';
import profileIconSpiritual from '../../../images/insight360/360-profile-icon_spiritual.png';
import profileIconFriends from '../../../images/insight360/360-profile-icon_friends.png';
import profileIconSocial from '../../../images/insight360/360-profile-icon_social.png';
import profileIconMetime from '../../../images/insight360/360-profile-icon_me-time.png';
import profileIconOutspoken from '../../../images/insight360/360-profile-icon_outspoken.png';
// Mri Brands..
// import mriBabyIcon from '../../../images/mri-icons/360-mri-baby-icon.png';
// import mriBeveragesIcon from '../../../images/mri-icons/360-mri-beverages-icon.png';
// import mriCandyIcon from '../../../images/mri-icons/360-mri-candy-icon.png';
// import mriLeisureSportsIcon from '../../../images/mri-icons/360-mri-leisure-sports-icon.png';
// import mriNewspaperIcon from '../../../images/mri-icons/360-mri-newspaper-icon.png';
// import mriNonFoodProductsIcon from '../../../images/mri-icons/360-mri-non-food-products-icon.png';
// import mriOccupationIcon from '../../../images/mri-icons/360-mri-occupation-icon.png';
// import mriPersonalItemIcon from '../../../images/mri-icons/360-mri-personal-item-icon.png';
// import mriPetsIcon from '../../../images/mri-icons/360-mri-pets-icon.png';
// import mriTobaccoIcon from '../../../images/mri-icons/360-mri-tobacco-icon.png';
// import mriRadioIcon from '../../../images/mri-icons/360-mri-radio-icon.png';


const iconComponents = [
  { id: '360GenericProfileIcon', selectedIcon: profileIcon },
  { id: '360ProfileIconHappyLife', selectedIcon: profileIconHappy },
  { id: '360ProfileIconInternational', selectedIcon: profileIconInternational },
  { id: '360ProfileIconMoney', selectedIcon: profileIconMoney },
  { id: '360ProfileIconOptimist', selectedIcon: profileIconOptimist },
  { id: '360ProfileIconPerfectionist', selectedIcon: profileIconPerfectionist },
  { id: '360ProfileIconRiskTaker', selectedIcon: profileIconRiskTaker },
  { id: '360ProfileIconStandOut', selectedIcon: profileIconStandOut },
  { id: '360ProfileIconWorkaholic', selectedIcon: profileIconWorkaholic },
  { id: '360ProfileIconWorry', selectedIcon: profileIconWorry },
  { id: '360ProfileIconAlone', selectedIcon: profileIconAlone },
  { id: '360ProfileIconArts', selectedIcon: profileIconArts },
  { id: '360ProfileIconCrime', selectedIcon: profileIconCrime },
  { id: '360ProfileIconFamily', selectedIcon: profileIconFamily },
  { id: '360ProfileIconSocialStatus', selectedIcon: profileIconSocialStatus },
  { id: '360ProfileIconFun', selectedIcon: profileIconFun },
  { id: '360ProfileIconEnvironmentalist', selectedIcon: profileIconEnvironmentalist },
  { id: '360ProfileIconSpiritual', selectedIcon: profileIconSpiritual },
  { id: '360ProfileIconFriends', selectedIcon: profileIconFriends },
  { id: '360ProfileIconSocial', selectedIcon: profileIconSocial },
  { id: '360ProfileIconMetime', selectedIcon: profileIconMetime },
  { id: '360ProfileIconOutspoken', selectedIcon: profileIconOutspoken },
  { id: '360ProfileIconSophisticated', selectedIcon: profileIconSophisticated },
];

const topSize = 5;

class ProfilesTripleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      profiles: [],
    };
  }

  getImageIcon = imageKey => {
    const icoImageKey = _.camelCase(imageKey.replace('.png', ''));
    const imageComponent = _.find(iconComponents, { id: icoImageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  resize = (arr, newSize, defaultValue) => {
    const tempArr = arr;
    while (newSize > tempArr.length) tempArr.push(defaultValue);
    tempArr.length = newSize;
    return tempArr;
  }

  fill(brandsOrMedia) {
    let profileData = brandsOrMedia;
    if (brandsOrMedia.length < topSize) {
      profileData = this.resize(profileData, 5, {
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'none.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
    }
    return profileData;
  }

  render() {
    return (
      <div className="row fullwidth" id="profileTriplePersonaPdf">
        <div className="row fullwidth demographic-detail-columns">
          <div id="profilePersonaFirstSection">
            {!_.isEmpty(this.props.profiles) &&
              this.props.profiles.length > 0 &&
              this.props.profiles.map((profile, index) => (
                <div key={index}>
                  <div className="columns large-4 medium-4 small-4 demographic-detail-columns">
                    <div
                      className={
                        index < this.props.profiles.length - 1
                          ? 'row fullwidth demographic-detail-columns profile-left-border profile-top-border'
                          : 'row fullwidth demographic-detail-columns profile-left-border profile-top-border profile-right-border'
                      }
                    >
                      <div className="columns large-4 small-4 medium-4 demographic-detail-columns">
                        <img
                          src={
                            Object.entries(profile)[0][1].value.icon === undefined
                              ? this.getImageIcon(
                                  _.camelCase(
                                    '360-generic-profile-icon.png'.replace(
                                      '.png',
                                      '',
                                    ),
                                  ),
                                )
                              : this.getImageIcon(
                                  _.camelCase(
                                    Object.entries(profile)[0][1].value.icon.replace(
                                      '.png',
                                      '',
                                    ),
                                  ),
                                )
                          }
                          className="i360-profile-persona-img-triple"
                          alt="Profile Icon"
                        />
                      </div>
                      <div className="columns large-8 small-8 medium-8 demographic-detail-columns">
                        <ProfilesTriplePersonality personality={Object.entries(profile)} />
                      </div>
                    </div>
                    <div
                      className={
                        index < this.props.profiles.length - 1
                          ? 'row fullwidth demographic-detail-columns profile-left-border profile-top-border'
                          : 'row fullwidth demographic-detail-columns profile-left-border profile-top-border profile-right-border'
                      }
                    >
                      <div className="columns large-12 small-12 medium-12">
                        <div className="row  fullwidth">
                        {Object.entries(profile).slice(getStartIndex(profile)).map((item, i) => (
                      <div className="columns large-6 small-6 medium-6 profile-triple-outlook-image-col
                      profile-float-left">
                        <ProfileTripleOutlookDetails
                          outlookDetail={item}
                          outlookHeading={item[0]}
                          label={item[1].label}
                          value={item[1].value}
                        />
                      </div>
                   ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="row fullwidth demographic-detail-columns profile-top-border profile-right-border  profile-left-border">
            <div className="columns large-12 small-12 medium-12 demographic-detail-columns  profile-top-border">
              <div className="profile-triple-comparasion-top-header">
                Top 5 Brands
              </div>
            </div>
          </div>
          <div id="profileTopBrands">
            {!_.isEmpty(this.props.profiles) &&
              this.props.profiles.length > 0 &&
              this.props.profiles.map((profile, index) => (
                <div key={index}>
                  <div
                    className="columns large-4 medium-4 small-4 demographic-detail-columns"
                    id="profileTopBrandsBorder"
                  >
                    {this.fill(
                      this.props.brands[index].brandList.slice(0, topSize),
                    ).map((brandDetail, i) => (
                      <div
                        className="row fullwidth demographic-detail-columns"
                        key={`prof-t-m${index + i}`}
                      >
                        <div className="columns large-12 small-12 medium-12 demographic-detail-columns">
                          {
                            <ProfileTripleComparisionDetail
                              key={i}
                              brandDetail={brandDetail}
                            />
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
          <div className="row fullwidth demographic-detail-columns  profile-top-border profile-right-border  profile-left-border">
            <div className="columns large-12 small-12 medium-12 demographic-detail-columns profile-top-border">
              <div className="profile-triple-comparasion-top-header">
                Top 5 Media
              </div>
            </div>
          </div>
          <div id="profileTopMedia">
            {!_.isEmpty(this.props.profiles) &&
              this.props.profiles.length > 0 &&
              this.props.profiles.map((profile, index) => (
                <div key={index}>
                  <div
                    className="columns large-4 medium-4 small-4 demographic-detail-columns"
                    id="profileTopBrandsBorder"
                  >
                    {this.fill(
                      this.props.medias[index].brandList.slice(0, topSize),
                    ).map((brandDetail, i) => (
                      <div
                        className="row fullwidth demographic-detail-columns"
                        key={`prof-t-b${index + i}`}
                      >
                        <div className="columns large-12 small-12 medium-12 demographic-detail-columns">
                          {
                            <ProfileTripleComparisionDetail
                              key={i}
                              brandDetail={brandDetail}
                            />
                          }
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

ProfilesTripleComparisionPersona.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.shape({})),
  brands: PropTypes.arrayOf(PropTypes.shape({})),
  medias: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps() {
  return {
    // state.insight360.demographics
  };
}

function mapDispatchToProps() {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(ProfilesTripleComparisionPersona);
